/**
 * @author: leroy
 * @date: 2021/11/26 11:43 上午
 * @description：常量数据
 */

// 截图尺寸
export const pictureOptions = {
  width: 1280,
  height: 720,
};

// 监控路由对应题号枚举
export const monitorEnum = {
  camera: { id: '-5', title: '调试摄像头', hashId: '5bBZ3Aj8aMWzYw04' },
  microphone: { id: '-4', title: '调试麦克风', hashId: 'NvZDjldE71JA391x' },
  screenSharing: { id: '-3', title: '屏幕共享', hashId: 'xjYLXA4JM8rzyQNE' },
  mobileDevice: { id: '-2', title: '调试手机', hashId: 'y90pOzYrpbalWYL2' },
  signature: { id: '-1', title: '诚信考试承诺书', hashId: '85xaol5aQralW7vR' },
};

// 风险帧枚举
export const riskEnum = {
  normal: { type: 0, title: '常规', id: 0 },
  cutScreen: { type: 1, title: '切屏到其他网站或软件', id: 1 },
  fullscreen: { type: 1, title: '取消全屏状态', id: 3 },
  offline: { type: 1, title: '考生断网', id: 10 },
  copyFromOther: { type: 2, title: '复制粘贴外网内容', id: 4 },
  camera: { type: 2, title: '第一视角摄像头异常', id: 11 },
  mobileDevice: { type: 2, title: '第二视角摄像头异常', id: 12 },
  microphone: { type: 2, title: '麦克风异常', id: 13 },
  screenSharing: { type: 2, title: '屏幕共享异常', id: 14 },
  usePhone: { type: 2, title: '考生使用手机', id: 7 },
  translate: { type: 2, title: '使用浏览器翻译插件', id: 19 },
  netInstability: { type: 1, title: '网络不稳定', id: 20 },
  changePhoneNumber: { type: 1, title: '切换手机号', id: 21 },

  jumpOverCamera: { type: 3, title: '第一视角摄像头跳过', id: 15 },
  jumpOverMicrophone: { type: 3, title: '麦克风跳过', id: 16 },
  jumpOverScreenSharing: { type: 3, title: '屏幕共享跳过', id: 17 },
  jumpOverMobileDevice: { type: 3, title: '第二视角摄像头跳过', id: 18 },
};

// 切题枚举
export const changeSubjectEnum = {
  // 点击上/下题
  prevAndNext: '1',
  // 点击题号
  goto: '2',
  // 点击交卷
  submit: '3',
  // 离开试卷
  leave: '4',
  // 重新进入试卷
  enter: '5',
  // 首次进入试卷
  firstEnter: '5',
};

// 题目类型枚举
export const examTypeEnum = {
  1: '单选题',
  2: '多选题',
  3: '不定项',
  4: '填空题',
  5: '问答题',
  6: '编程题',
  7: '判断题',
  8: '编程问答题',
  9: '阅读题',
  10: '听力题',
  11: '梯度选择',
};

// 试卷类型枚举
export const paperTypeEnum = {
  // 模拟试卷
  simulate: 0,
  // 定期试卷
  exam: 1,
  // 长期试卷
  longTime: 2,
};

// 反馈类型枚举
export const feedbackTypeEnum = {
  // 调试页
  monitor: 1,
  // 答题页
  exam: 2,
  // 完成页
  submit: 3,
};

// 编程语言枚举
export const languagesEnum = {
  C: 'c',
  C11: 'c',
  'C++': 'cpp',
  'C++14': 'cpp',
  'C++17': 'cpp',
  Java: 'java',
  Python2: 'python',
  Python3: 'python',
  PHP7: 'php',
  Javascript: 'javascript',
  Go: 'go',
  'C#': 'csharp',
  Ruby: 'ruby',
  Rust: 'rust',
  // 无
  Haskell: 'haskell',
  'Free Pascal': 'pascal',
  // 无
  'Free Basic': 'basic',
  Plaintext: 'plaintext',
  perl: 'perl',
  // 无
  bash: 'bash',
  CoffeeScript: 'coffeeScript',
  Julia: 'julia',
  Dart: 'dart',
  Lua: 'lua',
  // 无
  OCaml: 'ocaml',
};

//答题卡题目顺序排序
export const arrIndex = [1, 2, 11, 3, 7, 4, 10, 9, 5, 8, 6];

//语言默认头文件
export const header = {
  c: '#include <math.h>\n#include <stdio.h>\n#include <string.h>\n#include <stdlib.h>\n#include <assert.h>\n#include <limits.h>\n#include <stdbool.h>\n// 请使用如下标准样例代码读取输入和打印输出：\n// #include <stdio.h>\n// int main() {\n//    int a, b;\n//    while (scanf("%d %d", &a, &b) != EOF) { // 注意 while 处理多个 case\n//        // 64 位输出请用 printf("%lld")\n//        printf("%d\\n", a + b);\n//    }\n//    return 0;\n// }',
  cpp: '#include <iostream>\n#include <vector>\n#include <numeric>\n#include <limits>\n// 请使用如下标准样例代码读取输入和打印输出：\n// #include <stdio.h>\n// int main() {\n//    int a, b;\n//    while (scanf("%d %d", &a, &b) != EOF) { // 注意 while 处理多个 case\n//        // 64 位输出请用 printf("%lld")\n//        printf("%d\\n", a + b);\n//    }\n//    return 0;\n// }',
  cpp14:
    '#include <iostream>\n#include <vector>\n#include <numeric>\n#include <limits>\n// 请使用如下标准样例代码读取输入和打印输出：\n// #include <stdio.h>\n// int main() {\n//    int a, b;\n//    while (scanf("%d %d", &a, &b) != EOF) { // 注意 while 处理多个 case\n//        // 64 位输出请用 printf("%lld")\n//        printf("%d\\n", a + b);\n//    }\n//    return 0;\n// }',
  cpp17:
    '#include <iostream>\n#include <vector>\n#include <numeric>\n#include <limits>\n// 请使用如下标准样例代码读取输入和打印输出：\n// #include <stdio.h>\n// int main() {\n//    int a, b;\n//    while (scanf("%d %d", &a, &b) != EOF) { // 注意 while 处理多个 case\n//        // 64 位输出请用 printf("%lld")\n//        printf("%d\\n", a + b);\n//    }\n//    return 0;\n// }',
  csharp:
    'using System;\nusing System.Collections.Generic;\nusing System.IO;\nusing System.Linq;\n// 请使用如下标准样例代码读取输入和打印输出：\n// public class Program {\n//     public static void Main() {\n//         string line;\n//         while ((line = System.Console.ReadLine ()) != null) { // 注意 while 处理多个 case\n//             string[] tokens = line.Split();\n//             System.Console.WriteLine(int.Parse(tokens[0]) + int.Parse(tokens[1]));\n//         }\n//     }\n// }',
  go: 'package main\n// 请使用如下标准样例代码读取输入和打印输出：\n// package main\n\n// import (\n//     "fmt"\n// )\n// func main() {\n//     a := 0\n//     b := 0\n//     for {\n//         n, _ := fmt.Scan(&a, &b)\n//         if n == 0 {\n//             break\n//         } else {\n//             fmt.Printf("%d\\n", a + b)\n//         }\n//     }\n// }',
  java: 'import java.io.*;\nimport java.util.*;\n//请使用如下标准样例代码读取输入和打印输出：\n// import java.util.Scanner;\n// 注意类名必须为 Main, 不要有任何 package xxx 信息\n// public class Main {\n//     public static void main(String[] args) {\n        // Scanner in = new Scanner(System.in);\n        // 注意 hasNext 和 hasNextLine 的区别\n        // while (in.hasNextInt()) { // 注意 while 处理多个 case\n        //     int a = in.nextInt();\n        //     int b = in.nextInt();\n        //     System.out.println(a + b);\n        // }\n//     }\n// }',
  javascript:
    "// 请使用如下标准样例代码读取输入和打印输出：\n// const readline = require('readline');\n\n// const rl = readline.createInterface({\n//     input: process.stdin,\n//     output: process.stdout\n// });\n// rl.on('line', function (line) {\n//     const tokens = line.split(' ');\n//     console.log(parseInt(tokens[0]) + parseInt(tokens[1]));\n// });",
  php: '// 请使用如下标准样例代码读取输入和打印输出：\n// <?php\n// while(fscanf(STDIN, "%d %d", $a, $b) == 2)\n//     echo ($a + $b)."\\n";',
  python:
    "#!/bin/python\n# -*- coding: utf8 -*-\nimport sys\nimport os\nimport re\n# 请使用如下标准样例代码读取输入和打印输出：\n# import sys\n\n# try:\n#     while True:\n#         line = sys.stdin.readline().strip()\n#         if line == '':\n#             break\n#         lines = line.split()\n#         print int(lines[0]) + int(lines[1])\n# except:\n#     pass",
  ruby: '# 请使用如下标准样例代码读取输入和打印输出：\n# while (line = STDIN.gets)\n#     a, b = line.split(" ").map { |x| x.to_i }\n#     puts (a + b)\n# end',
  rust: 'use std::io;\n// 请使用如下标准样例代码读取输入和打印输出：\n// use std::io::{self, *};\n\n// fn main() {\n//     let stdin = io::stdin();\n//     unsafe {\n//         for line in stdin.lock().lines() {\n//             let ll = line.unwrap();\n//             let numbers: Vec<&str> = ll.split(" ").collect();\n//             let a = numbers[0].trim().parse::<i32>().unwrap_or(0);\n//             let b = numbers[1].trim().parse::<i32>().unwrap_or(0);\n//             print!("{}\\n", a + b);\n//         }\n//     }\n// }',
};

//测评试卷时间(分钟)
export const evaluationTimeEnum = {
  '2': 15,
  '3': 35,
};

export const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'code-block',
  'list',
  'align',
  'bullet',
  'indent',
  'link',
  'image',
];
